import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';

import { UitkTextInput } from 'uitk-react-input';

import { PropertyDetailsSegment } from 'components/infosite/property-information/internals/property-details-segment';

const TrackedTextInput = ClickTracker(UitkTextInput);

export const HisBottomEntry = ({ listClasses, headerTitle, placeholder, jsEnabled, onFocus }) => (
  <PropertyDetailsSegment
    errorBoundaryLabel="section-info-find-answers-2"
    dataStid="section-info-find-answers-2"
    rootClassName="info-find-answers"
    title={null}
    isToggleHidden={false}
  >
    <span className="uitk-type-heading-500">{headerTitle}</span>
    <div className={listClasses}>
      <div className="property-policies-check-in all-t-padding-three">
        <TrackedTextInput
          onFocus={onFocus}
          value=""
          label="Find Answers"
          placeholder={placeholder}
          id="findAnswerBottomEntry"
          icon="search"
          name="findAnswerBottomEntry"
          disabled={!jsEnabled}
          hasVisibleLabel={false}
          linkName="Open from BottomEntry"
          rfrr="AskQuestion.FindAnswersBottomEntry"
        />
      </div>
    </div>
  </PropertyDetailsSegment>
);

HisBottomEntry.displayName = 'HisBottomEntry';
